import useClientMetrics from "hooks/useClientMetrics";
import { useEffect } from "react";
import { getBrandedFarePriceMismatchMetricName } from "branded-fares/components/FareSelector/utils";
import { UIBrandedFare, UIFlightData } from "@flights/types";
import useEvents from "hooks/useEvents";
import { carrierUtils } from "@flights/web-api-utils-universal";

export default function useTrackFirstFarePriceMismatch(
  flight: UIFlightData,
  brandedFareOffers: UIBrandedFare[] | undefined
) {
  const { trackClientMetric } = useClientMetrics();
  const { grumble } = useEvents();

  useEffect(() => {
    if (brandedFareOffers && brandedFareOffers.length > 0) {
      const firstFare = brandedFareOffers[0];
      const carriers = carrierUtils.getUniqueMarketingCarriers(flight.segments);
      const pointOfSale = flight.pointOfSale;

      trackClientMetric(
        getBrandedFarePriceMismatchMetricName(
          flight.priceBreakdown.total,
          firstFare.priceBreakdown.total,
          carriers,
          pointOfSale,
          grumble
        )
      );
    }
  }, [brandedFareOffers, flight, trackClientMetric, grumble]);
}
